<template>
  <table class="device-list">
    <thead>
      <tr>
        <th>Profile Token</th>
        <th>Reg. Date</th>
        <th>Reg. Time</th>
        <th>Platform</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="device in registeredDevices" :key="device.key">
        <td>{{device.getActiveString('profile_token')}}</td>
        <td>{{device.getActiveDate('service_time').toLocaleDateString()}}</td>
        <td>{{device.getActiveDate('service_time').toLocaleTimeString()}}</td>
        <td>{{device.getActiveString('platform')}}</td>
        <td><device-message-composer :device="device" /></td>
      </tr>
    </tbody>
  </table>
</template>
<script>
  import {mapGetters} from 'vuex'

  var timer = null

  export default {
    computed: {
      ...mapGetters({
        amazonAuthenticated: 'amazonAuthenticated',
        registeredDevices: 'registeredDevices'
      })
    },
    mounted: function () {
      if (!this.amazonAuthenticated) {
        this.$router.push('/unlock-secret')
      }

      this.updateDevices()
      timer = setInterval(() => {
        if (this.ddb) {
          console.log('...refresh devices...')
          this.updateDevices()
        }
      }, 20000)
    },
    methods: {
      updateDevices: function () {
        this.$store.dispatch('refreshRegisteredDevices')
      }
    },
    beforeDestroy: function () {
      clearInterval(timer)
    }
  }
</script>
<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/ConnectedDevices.vue